const defaultLang = process.env.DEFAULT_LANGUAGE;
export const configData = {
  data() {
    return {
      FIXED: 'duration_fixed',
      PICKER: 'duration_picker',
      FIXED_ENTRY: 'fixed_entry',
      LANGUAGES: getLanguages(),
      DEF_LANG: defaultLang,
    };
  },
};

const getLanguages = () => {
  switch (defaultLang){
    case 'fi':
      return {
        fi: 'Finnish',
        en: 'English',
      };
    case 'lv':
      return {
        lv: 'Latvian',
        en: 'English',
      };
    default:
      return {
        en: 'English',
        et: 'Estonian',
        ru: 'Russian',
      };
  }
}



// WEBPACK FOOTER //
// ./src/components/tenants/ticket-types/mixins/configData.js